import { connect } from 'react-redux';

import MonthView from '~/Components/Pages/Calendar/MonthView/MonthView';
import { setMonthType } from '~/Redux/Modules/DateRange';
import { getQuoteByDate } from '~/Redux/Modules/Quote';

const mapStateToProps = ({ DateRange, UserOptions }) => {
  return {
    start: DateRange.start,
    useMondayStart: UserOptions.data.use_monday_start,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getMonthlyQuote: start => dispatch(getQuoteByDate(start)),
    setMonthType: monthStart => dispatch(setMonthType(monthStart.clone(), false)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MonthView);
